import React from "react";
import { IFormFunctionProps } from "src/components/Form/FormAccordionContainer";
import { useClaimEffects } from "./hooks/useClaimEffects";
import HomeUserClaimFormContent from "src/components/Form/Claim/HomeUserClaimFormContent";
import ClaimFormContent from "src/components/Form/Claim/ClaimFormContent";

export const ContentSection: React.FC<IFormFunctionProps> = (
  props: IFormFunctionProps
) => {
  const { isHomeUser, dialogValues } = useClaimEffects();
  return (
    <>
      {isHomeUser ? (
        <HomeUserClaimFormContent
          {...props}
          dialogValues={dialogValues}
          homeUser={isHomeUser}
        />
      ) : (
        <ClaimFormContent {...props} dialogValues={dialogValues} />
      )}
    </>
  );
};
